import './style.css';
import React, { Component } from 'react';
import {
  HierarchicalTree,
  StackPanel,
  ImageElement,
  TextElement,
  SnapConstraints,
  DiagramComponent,
  Inject,
  DataBinding,
  OverviewComponent,
  DiagramTools,
} from '@syncfusion/ej2-react-diagrams';
import {
  TabComponent,
  TabItemDirective,
  TabItemsDirective,
} from '@syncfusion/ej2-react-navigations';
import { DropDownListComponent } from '@syncfusion/ej2-react-dropdowns';
import { ThemeContext } from '../../context/theme.context';

import Assignment from './Assignment';
import Teams from './Teams';
import Trade from './Trades';
import ResourceMaster from './ResourceMaster';
import TrainingAndCertification from './TrainingAndCertification';
interface IState {
  teamData: Array<any>;
  tradesData: Array<any>;
  assignData: Array<any>;
}
interface IProp {}
export default class TradePerson extends Component<IProp, IState> {
  private diagramInstance: DiagramComponent;

  static contextType = ThemeContext;
  context!: React.ContextType<typeof ThemeContext>;
  constructor(props: IProp) {
    super(props);
    this.diagramInstance = new DiagramComponent(props);
    this.state = {
      teamData: [],
      tradesData: [],
      assignData: [],
    };
  }
  setNodeTemplate(obj: any, diagram: any) {
    let content = new StackPanel();
    content.id = obj.id + '_outerstack';
    content.orientation = 'Horizontal';
    content.style.strokeColor = 'gray';
    content.padding = { left: 5, right: 10, top: 5, bottom: 5 };
    let image = new ImageElement();
    image.width = 50;
    image.height = 50;
    image.style.strokeColor = 'none';
    image.source = obj.data.ImageUrl;
    image.id = obj.id + '_pic';
    let innerStack = new StackPanel();
    innerStack.style.strokeColor = 'none';
    innerStack.margin = { left: 5, right: 0, top: 0, bottom: 0 };
    innerStack.id = obj.id + '_innerstack';
    let text = new TextElement();
    text.content = obj.data.Name;
    text.style.color = 'black';
    text.style.bold = true;
    text.style.strokeColor = 'none';
    text.style.fill = 'none';
    text.id = obj.id + '_text1';
    let desigText = new TextElement();
    desigText.margin = { left: 0, right: 0, top: 5, bottom: 0 };
    desigText.content = obj.data.Designation;
    desigText.style.color = 'black';
    desigText.style.strokeColor = 'none';
    desigText.style.fill = 'none';
    desigText.style.textWrapping = 'Wrap';
    desigText.id = obj.id + '_desig';
    innerStack.children = [text, desigText];
    content.children = [image, innerStack];
    return content;
  }

  diagramComponent = () => {
    return (
      <div>
        <DiagramComponent
          id='diagram'
          ref={(diagram) =>
            (this.diagramInstance = diagram as DiagramComponent)
          }
          width={'110%'}
          height={'650px'}
          tool={DiagramTools.ZoomPan}
          scrollSettings={{ scrollLimit: 'Diagram' }} //Sets the constraints of the SnapSettings
          snapSettings={{ constraints: SnapConstraints.None }} //Configrues organizational chart layout
          layout={{
            type: 'OrganizationalChart',
            margin: { top: 20 },
            getLayoutInfo: (node: any, tree: any) => {
              if (!tree.hasSubTree) {
                tree.orientation = 'Vertical';
                tree.type = 'Right';
              }
            },
          }} //Sets the parent and child relationship of DataSource.
          dataSourceSettings={{
            id: 'Id',
            parentId: 'ReportingPerson',
            // dataSource: data,
          }} //Sets the default values of Nodes
          getNodeDefaults={(obj: any, diagram: any) => {
            obj.height = 50;
            obj.style = { fill: 'transparent', strokeWidth: 2 };
            return obj;
          }} //Sets the default values of connector
          getConnectorDefaults={(connector: any, diagram: any) => {
            connector.targetDecorator.shape = 'None';
            connector.type = 'Orthogonal';
            return connector;
          }}
          //customization of the node.
          setNodeTemplate={(obj: any, diagram: any) => {
            return this.setNodeTemplate(obj, diagram);
          }}
          backgroundColor={this.context.isDarkMode ? '#15202B' : '#eaeef0'}
          diagramSettings={{ inversedAlignment: false }}
          mode={'SVG'}
        >
          <Inject services={[DataBinding, HierarchicalTree]} />
        </DiagramComponent>
        <div className='col-lg-4 overview'>
          <OverviewComponent
            id='overview'
            style={{}}
            sourceID='diagram'
            width={'100%'}
            height={'150px'}
          />
        </div>
        <div className='teamSelector'>
          <DropDownListComponent
            dataSource={['Team A', 'Team C', 'Team B']}
            placeholder={'Select Team'}
          />
        </div>
      </div>
    );
  };
  componentDidMount() {}
  Team = () => {
    return <Teams />;
  };
  Trades = () => {
    return <Trade />;
  };
  Assignment = () => {
    return <Assignment />;
  };
  ResourceMaster = () => {
    return <ResourceMaster />;
  };
  Training = () => {
    return <TrainingAndCertification />;
  };
  render() {
    return (
      <div>
        <TabComponent
          heightAdjustMode='Auto'
          id='defaultTab'
          statelessTemplates={['directiveTemplates']}
        >
          <TabItemsDirective>
            <TabItemDirective
              header={{ text: 'Org. Chart' }}
              content={this.diagramComponent.bind(this)}
            />
            <TabItemDirective
              header={{ text: 'Teams' }}
              content={this.Team.bind(this)}
            />
            <TabItemDirective
              header={{ text: 'Trades' }}
              content={this.Trades.bind(this)}
            />
            <TabItemDirective
              header={{ text: 'Trades Person' }}
              content={this.Assignment.bind(this)}
            />
            <TabItemDirective
              header={{ text: 'Training and Certification' }}
              content={this.Training.bind(this)}
            />
            <TabItemDirective
              header={{ text: 'Resource Master' }}
              content={this.ResourceMaster.bind(this)}
            />
          </TabItemsDirective>
        </TabComponent>
      </div>
    );
  }
}
